// TURBO:LOAD
document.addEventListener("turbo:load", () => {
  $(".cep_search").keyup(function () {
    const cep = $(this).val();
    const filter_cep = cep.replace(/\D/g, "");

    if (filter_cep.length === 8) {
      $.get(
        "https://viacep.com.br/ws/" + filter_cep + "/json/",
        {},
        function (data) {
          if (data && !data.erro) {
            $(".neighborhood_search").val(data.bairro || "");
            $(".street_search").val(data.logradouro || "");

            const uf = (data.uf || "").toUpperCase();
            const $stateSelect = $(".state_search");

            if (uf && $stateSelect.length) {
              const $option = $stateSelect
                .find("option")
                .filter(function () {
                  const text = ($(this).text() || "").toUpperCase().trim();
                  return text.endsWith("(" + uf + ")");
                })
                .first();

              if ($option.length) {
                $stateSelect.val($option.val());
              }
            }

            $(".city_search").val("");
            $(".city_search").html("");
            $(".city_search").append(
              '<option value="">Selecione a Cidade</option>',
            );

            if (data.localidade) {
              var newOption = new Option(
                data.localidade,
                data.localidade,
                true,
                true,
              );
              $(".city_search").append(newOption);
            }
          } else {
            $(".neighborhood_search").val("");
            $(".street_search").val("");
            $(".state_search").val("");
            $(".city_search").val("");
            $(".city_search").html(
              '<option value="">CEP n\u00e3o encontrado</option>',
            );
          }
        },
      );
    }
  });
}); // END TURBO:LOAD
